import { memoize } from 'lodash-es'
import { Color } from './color'
import type { Loose } from '~/api/interface'

export function isThenable(obj: any) {
  return obj != null && typeof obj.then === 'function'
}

function loadImage(link: string) {
  return new Promise<HTMLImageElement>((resolve, reject) => {
    const img = new Image()
    img.src = link
    img.crossOrigin = 'anonymous'
    img.onload = () => resolve(img)
    img.onerror = () => reject(img)
  })
}

export const getPicturePointColor = memoize(
  async (link: string, destination?: { x: number; y: number }) => {
    const img = await loadImage(link)
    const cvs = document.createElement('canvas')

    const ctx = cvs.getContext('2d')

    ctx!.drawImage(img, 0, 0, img.width, img.height)

    const x = destination?.x || 0
    const y = destination?.y || 0
    const imageData = ctx?.getImageData(x, y, 1, 1)
    if (imageData?.data) {
      return Color.fromRGBA({
        r: imageData?.data[0],
        g: imageData?.data[1],
        b: imageData?.data[2],
        a: imageData?.data[3],
      })
    }
  }
)

export const getVideoPoster = memoize((link: string) => {
  return new Promise<string>((resolve, reject) => {
    const cvs = document.createElement('canvas')
    const ctx = cvs.getContext('2d')
    const video = document.createElement('video')
    video.muted = true
    video.crossOrigin = 'anonymous'
    video.src = link

    video.onloadeddata = () => {
      video.currentTime = 1
      // video.play()
    }

    // 监听视频帧可用事件
    video.onseeked = () => {
      cvs.width = video.videoWidth
      cvs.height = video.videoHeight
      ctx?.drawImage(video, 0, 0, cvs.width, cvs.height)
      video.pause()
      resolve(cvs.toDataURL('image/jpeg'))
    }

    video.onerror = () => {
      reject(new Error('Video Poster Generate Error'))
    }
  })
})

export const redirectQueryPPT = (redirect?: string) => {
  if (!redirect) {
    return {
      from_ppt_activity: 0,
    }
  }

  const [, query] = redirect.split('?')
  if (!query) {
    return {
      from_ppt_activity: redirect?.includes('/ppt-world') ? 1 : 0,
    }
  }
  const res = {} as Loose
  query.split('&').forEach((v) => {
    const [key, value] = v.split('=')
    if (key === 'pcode') {
      res.channel_code = value
    }
  })
  res.from_ppt_activity = redirect?.includes('/ppt-world') ? 1 : 0
  return res
}

export const formatByteSize = (size: number) => {
  let current = size
  const unit = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
  let pos = 0
  while (current >= 1024) {
    current /= 1024
    pos += 1
  }
  return `${current.toFixed(2)}${unit[pos]}`
}

export const deepOmit = <T extends Record<string, any>>(
  obj: T,
  keys: string[]
) => {
  Object.keys(obj).forEach((key) => {
    if (keys.includes(key)) {
      delete obj[key]
    }
    if (typeof obj[key] === 'object' && obj[key] !== null) {
      deepOmit(obj[key], keys)
    }
  })
}
